import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RegisterComponent } from './register/RegisterComponent'

const RegisterManagementRoutes: Routes = [
        { 
            path: 'sign-on',
            component: RegisterComponent
        },
];

export const registerManagementRouting: ModuleWithProviders = RouterModule.forChild(RegisterManagementRoutes);


// WEBPACK FOOTER //
// ./src/holiday/parent/register-management/RegisterRouting.ts